module.exports = __webpack_public_path__ + "img/facebookDark.23aa9061.svg";